import config from "../config";
import { sendGetRequest, sendPutRequest } from "../Utility/FetchUtils";
import { PreferenceFile, PreferenceValue } from "../Model/Preference";

export default class PreferenceApi {
  static BASE_URL = config.SERVICE_URL + "/Preference";

  static getPreferences() {
    const url = `${this.BASE_URL}/collection`;
    return sendGetRequest<PreferenceFile[]>(url);
  }

  static setPreferences(preferenceValues: PreferenceValue[]) {
    const url = `${this.BASE_URL}/values`;
    
    return sendPutRequest(url, preferenceValues);
  }
}
